<div *ngIf="disabled ? false: active "
     class="app-card-box w-100 mt-sm px-sm py-sm ts-caption">
  <ng-content></ng-content>
</div>
